import { InfiniteData } from '@tanstack/react-query'

import type { ClientError } from '@tribeplatform/gql-client/lib'
import {
  Action,
  MutationDeclineSpaceMembershipRequestArgs,
  PaginatedSpaceJoinRequest,
} from '@tribeplatform/gql-client/types'

import {
  useMutation,
  UseMutationOptions,
} from '../../lib/react-query/useMutation.js'
import { useQueryClient } from '../../lib/react-query/useQueryClient.js'
import { useTribeClient } from '../../useTribeClient.js'
import { getSpaceJoinRequestKey } from '../../utils/keys/spaceMembership.key.js'

export const useDeclineSpaceMembershipRequest = (options?: {
  useMutationOptions?: UseMutationOptions<
    Action,
    ClientError,
    MutationDeclineSpaceMembershipRequestArgs
  >
}) => {
  const { useMutationOptions } = options || {}
  const { client } = useTribeClient()
  const queryClient = useQueryClient()
  const spaceJoinRequestsKey = getSpaceJoinRequestKey()

  return useMutation<
    Action,
    ClientError,
    MutationDeclineSpaceMembershipRequestArgs
  >(variables => client.spaceMembership.declineRequest(variables), {
    onMutate: variables => {
      queryClient.setQueriesData<InfiniteData<PaginatedSpaceJoinRequest>>(
        spaceJoinRequestsKey,
        old => ({
          ...old,
          pages: old?.pages?.map(page => ({
            ...page,
            nodes: page.nodes?.filter(
              node => node.id !== variables.spaceMembershipRequestId,
            ),
          })),
        }),
      )
    },
    onSettled: () => {
      queryClient.invalidateQueries(spaceJoinRequestsKey)
    },
    ...useMutationOptions,
  })
}
